import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import CartUpdater from "../../../context/cartUpdater"
import { useSnackbar } from "../../../context/snackbar"

function ListDetail() {
  const { id } = useParams()
  const { showSnackbar } = useSnackbar()

  const API = `${process.env.REACT_APP_API_URL}/api/lists/${id}`

  const [list, setList] = useState(null)
  const [loading, setLoading] = useState(true)
  const [refresh, setRefresh] = useState(true)

  /* =========================
     FETCH LIST
  ========================= */
  useEffect(() => {
    const fetchList = async () => {
      try {
        const res = await fetch(API, {
          credentials: "include",
        })

        const data = await res.json()

        if (res.ok) {
          setList(data)
        } else {
          showSnackbar(data.message || "Failed to load list", "error")
        }

        setLoading(false)
        setRefresh(false)
      } catch (err) {
        console.error("Fetch list error:", err)
        showSnackbar("Something went wrong", "error")
        setLoading(false)
      }
    }

    if (refresh) fetchList()
  }, [API, refresh, showSnackbar])

  /* =========================
     REMOVE ITEM
  ========================= */
  const removeItem = async (productId) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/lists/${id}/items/${productId}`,
        {
          method: "DELETE",
          credentials: "include",
        },
      )

      const data = await res.json()

      if (!res.ok) {
        showSnackbar(data.message || "Failed to remove item", "error")
        return
      }

      showSnackbar("Item removed from list", "success")
      setRefresh(true)
    } catch (err) {
      console.error("Remove item error:", err)
      showSnackbar("Something went wrong", "error")
    }
  }

  /* =========================
     LOADING STATE
  ========================= */
  if (loading) return <h3>Loading list...</h3>
  if (!list) return <h3>List not found</h3>

  /* =========================
     RENDER
  ========================= */
  return (
    <div className="col-12 d-flex flex-column align-items-center">
      <h2 className="display-5">{list.name}</h2>
      <p className="text-muted">{list.items?.length || 0} items</p>

      <div className="col-lg-6 col-md-8 col-sm-10">
        {list.items?.length === 0 && (
          <p className="text-muted">No items in this list</p>
        )}

        {list.items?.map((item) => (
          <div
            key={item.product._id || item.product_id}
            className="border p-2 d-flex align-items-center justify-content-between my-2"
          >
            {/* LEFT SIDE */}
            <div className="d-flex align-items-center">
              <img
                src={item.image}
                alt={item.name}
                style={{
                  width: "60px",
                  height: "60px",
                  objectFit: "cover",
                }}
              />

              <div className="ms-3">
                <h6 className="mb-0">{item.name}</h6>
                <small>₱{item.price}</small>
              </div>
            </div>

            {/* ACTIONS */}
            <div className="d-flex gap-2">
              {/* ADD TO CART */}
              <CartUpdater
                classes="btn-sm"
                item={{
                  product_id: item.product_id,
                  name: item.name,
                  price: item.price,
                  qty: 1,
                  image: item.image,
                }}
              />

              {/* REMOVE */}
              <button
                className="btn btn-danger btn-sm"
                onClick={() => removeItem(item.product._id)}
              >
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ListDetail
